module.exports = __webpack_public_path__ + "static/media/pengalihan_dana.7edcd549.png";